import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "../../button/button.js";
import "./styles.css";

const TableLink = ({ value, path, state }) => {
  const navigate = useNavigate();
  
  return state ? (
    // <Button variant="link">
    //   <Link to={path} state={state}>
    //     {value}
    //   </Link>
    // </Button>
    <Link
      to={path}
      state={state}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Button variant="link">{value}</Button>
    </Link>
  ) : (
    <Link
      to={path}
      className="table-link-container"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Button variant="link">
        {value}
      </Button>
    </Link>
  );
};

export default TableLink;
